import CustomModal from "../../components/modal/customModal";
import Button from "../../components/button/button";
import {ButtonStatus} from "../../components/button/enum";
import React, {useEffect, useState} from "react";

export enum SubscribeStatus {
    unsubscribed,
    subscribed,
}

export enum OpenRate {
    lessThan30,
    between30and50,
    moreThan50,
}

export interface PatientFilterOptionSetting {
    id: number,
    title: string,
    desc: string
}

export interface PatientFilterSetting {
    status?: PatientFilterOptionSetting,
    openRate?: PatientFilterOptionSetting,
}

export const DefaultPatientFilterSetting: PatientFilterSetting = {
    status: undefined,
    openRate: undefined,
}

enum PatientFilterSettingType {
    status,
    openRate,
}

interface OptionItem {
    id: number,
    title: string,
}

const PatientFilterSettingData = [
    {
        type: PatientFilterSettingType.status,
        title: "Status",
        options: [
            {id: SubscribeStatus.subscribed, title: "Subscribed"},
            {id: SubscribeStatus.unsubscribed, title: "Unsubscribed"},
        ],
    },
    {
        type: PatientFilterSettingType.openRate,
        title: "Open Rate",
        options: [
            {id: OpenRate.lessThan30, title: "Less than 30%"},
            {id: OpenRate.between30and50, title: "30 - 50%"},
            {id: OpenRate.moreThan50, title: "More than 50%"},
        ],
    },
]

interface IProps {
    isOpen: boolean,
    filterSetting?: PatientFilterSetting,
    onCancel: () => void,
    onApply: (setting: PatientFilterSetting) => void,
}

export default function PatientFilter(props: IProps) {
    const {isOpen, filterSetting = DefaultPatientFilterSetting, onCancel, onApply} = props
    const [setting, setSetting] = useState<PatientFilterSetting>(filterSetting)

    useEffect(() => {
        setSetting(filterSetting)
    }, [filterSetting])

    const $header = (
        <div className={""}>
            <p className={"text-lg text-gray-2 font-semibold"}>Filter Patients</p>
        </div>
    )

    const renderSettingUnit = (idx: number, title: string, isSelected: boolean, onChange: () => void) => {
        return (
            <div key={idx} className={"flex flex-row items-center py-2"}>
                <input checked={isSelected} onChange={onChange} type="checkbox" className={`form-checkbox h-3.5 w-3.5 rounded mr-3 ${isSelected ? "" : "focus:ring-0 focus:ring-white"}`} />
                <p className={"text-base text-gray-2"}>{title}</p>
            </div>
        )
    }

    const renderSettingItem = (type: PatientFilterSettingType, title: string, options: Array<OptionItem>, idx: number) => {
        const checkIsSelected = (id: number) => {
            if (type === PatientFilterSettingType.status) {
                return id === setting.status?.id
            } else if (type === PatientFilterSettingType.openRate) {
                return id === setting.openRate?.id
            }
            return false
        }
        return (
            <div key={idx} className={"flex flex-col"}>
                <p className={"text-base text-gray-2 font-semibold py-2"}>{title}</p>
                <div className={"flex flex-row items-center space-x-6"}>
                    {options.map((option, idx) => renderSettingUnit(idx, option.title, checkIsSelected(option.id), () => {
                        if (type === PatientFilterSettingType.status) {
                            setSetting({
                                ...setting,
                                status: setting.status?.id === option.id ? undefined : {id: option.id, title: title, desc: option.title},
                            })
                        } else if (type === PatientFilterSettingType.openRate) {
                            setSetting({
                                ...setting,
                                openRate: setting.openRate?.id === option.id ? undefined : {id: option.id, title: title, desc: option.title},
                            })
                        }
                    }))}
                </div>
            </div>
        )
    }

    const $content = (
        <div className={"flex flex-col py-4"}>
            {PatientFilterSettingData.map(({type, title, options}, idx) => renderSettingItem(type, title, options, idx))}
        </div>
    )

    const $footer = (
        <div className={"flex flex-row justify-end items-center space-x-4 pt-6 border-t"}>
            <Button status={ButtonStatus.light} onClick={() => {
                setSetting(filterSetting)
                onCancel && onCancel()
            }}>Cancel</Button>
            <Button status={ButtonStatus.primary} onClick={() => {
                onApply && onApply(setting)
            }}>Apply Filter</Button>
        </div>
    )

    return (
        <CustomModal isOpen={isOpen}>
            <div className={"flex flex-col p-4"}>
                {$header}
                {$content}
                {$footer}
            </div>
        </CustomModal>
    )
}
